export default __webpack_public_path__ + "static/media/Wifi_Dark.9c113f37.svg";